<div style="padding: 20px 20px">
  <div style="display: flex; gap: 100px">
    <div
      style="
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        gap: 20px;
        width: 200px;
      "
    >
      <button matButton="filled">Primary</button>
      <button matButton="filled" class="app-btn-small">Primary</button>
      <button matButton="filled" disabled>Primary Disa.</button>
      <button matButton="outlined">Secondary</button>
      <button matButton="outlined" disabled>Secondary Dis.</button>
      <button matButton="elevated" class="app-btn-small">Tertiary Stroke</button>
      <button matButton="elevated" disabled>Tertiary Dis.</button>
      <button matButton="tonal">Tertiary</button>
      <button matButton="tonal" disabled>Tertiary Dis.</button>
      <button matButton="filled" class="app-btn-destructive">Dest. Primary</button>
      <button matButton="outlined" class="app-btn-destructive">Dest. Secondary</button>
      <button matButton="elevated" class="app-btn-destructive">Dest. Ter. Stroke</button>
      <button matButton="tonal" class="app-btn-destructive">Dest. Tertiary</button>
      <button matButton="filled" class="app-btn-destructive app-btn-small">Dest. Small</button>
    </div>
    <div style="display: flex; flex-direction: column; gap: 20px">
      <mat-checkbox>Normal unselected</mat-checkbox>

      <mat-checkbox [checked]="true"> Normal selected </mat-checkbox>

      <mat-checkbox [indeterminate]="true"> Normal indeterminate </mat-checkbox>

      <mat-checkbox class="app-checkbox-error"> Error unselected </mat-checkbox>

      <mat-checkbox class="app-checkbox-error" [checked]="true"> Error selected </mat-checkbox>

      <mat-checkbox class="app-checkbox-error" [indeterminate]="true">
        Error indeterminate
      </mat-checkbox>

      <mat-radio-button value="one">Normal</mat-radio-button>

      <mat-radio-button value="delete" class="app-radio-error"> Error </mat-radio-button>

      <mat-slide-toggle>Normal</mat-slide-toggle>
    </div>
    <div style="display: flex; flex-direction: column; gap: 10px">
      <app-status-label [status]="statuses.ACTIVE"></app-status-label>
      <app-status-label [status]="statuses.ACTIVE" size="small"></app-status-label>

      <app-status-label [status]="statuses.ERROR"></app-status-label>
      <app-status-label [status]="statuses.PENDING"></app-status-label>
      <app-status-label [status]="statuses.DISABLED"></app-status-label>
      <app-status-label [status]="statuses.IN_PROGRESS"></app-status-label>
    </div>
    <div>
      <button matButton="filled" (click)="showModalDialog()">Show modal</button>
    </div>
    <div>
      <button matButton="filled" (click)="showSnackbar()">Show snackbar</button>
    </div>
  </div>
</div>
